import _ from 'lodash';
import React, { Component } from 'react';
import * as CLIntF from '../../../interfaces/classroomLessons';
import StudentMultistep from '../../classroomLessons/play/multistep';
import PromptField from './slideComponents/promptField';
import SlidePreview from './slideComponents/slidePreview';
import TextField from './slideComponents/textField';
import TitleField from './slideComponents/titleField';
import CuesField from './slideComponents/cuesField';
import { Input, parseCues } from '../../../../Shared/index';

interface CustomizeMultistepProps {
  question: CLIntF.QuestionData,
  updateQuestion: Function,
  clearSlide: Function,
  resetSlide: Function,
  questionIndex: number,
  incompletePrompt: Boolean
}

class CustomizeMultistep extends Component<CustomizeMultistepProps, {}>{
  constructor(props){
    super(props);

    this.handleTitleChange = this.handleTitleChange.bind(this)
    this.handlePromptChange = this.handlePromptChange.bind(this)
    this.handleInstructionsChange = this.handleInstructionsChange.bind(this)
    this.handleCuesChange = this.handleCuesChange.bind(this)
    this.updateQuestion = this.updateQuestion.bind(this)
  }

  updateQuestion(newVals, questionIndex) {
    this.props.updateQuestion(newVals, questionIndex)
  }

  handleTitleChange(e) {
    const newVals = _.merge({}, this.props.question)
    _.set(newVals, 'teach.title', e.target.value)
    this.updateQuestion(newVals, this.props.questionIndex)
  }

  handlePromptChange(e) {
    const newVals = _.merge({}, this.props.question)
    _.set(newVals, 'play.prompt', e)
    this.updateQuestion(newVals, this.props.questionIndex)
  }

  handleInstructionsChange(e) {
    const newVals = _.merge({}, this.props.question)
    _.set(newVals, 'play.instructions', e.target.value)
    this.updateQuestion(newVals, this.props.questionIndex)
  }

  handleCuesChange(e) {
    const newVals = _.merge({}, this.props.question)
    const formattedCues = parseCues(e.target.value);
    _.set(newVals, 'play.cues', formattedCues)
    this.updateQuestion(newVals, this.props.questionIndex)
  }

  handleStepLabelChange(e, i) {
    const newVals = _.merge({}, this.props.question)
    const newStepLabels = this.props.question.play.stepLabels.slice()
    newStepLabels[i] = e.target.value
    _.set(newVals, 'play.stepLabels', newStepLabels)
    this.updateQuestion(newVals, this.props.questionIndex)
  }

  renderStepLabels() {
    return this.props.question.play.stepLabels.map((sl, i) => (
      <Input
        ariaLabel={`Label for Field ${i}`}
        className="bordered large"
        handleChange={(e) => this.handleStepLabelChange(e, i)}
        key={i}
        value={sl || ''}
      />
    ))
  }

  render() {
    const { clearSlide, questionIndex, resetSlide, question, incompletePrompt, } = this.props
    const instructionsInputId = `instructions-${questionIndex}`

    return (
      <div className="slide">
        <div className="form">
          <TitleField
            clearSlide={clearSlide}
            handleTitleChange={this.handleTitleChange}
            questionIndex={questionIndex}
            resetSlide={resetSlide}
            title={question.teach.title}
          />
          <PromptField
            handleTextChange={(e) => this.handlePromptChange(e)}
            incompletePrompt={incompletePrompt}
            questionIndex={questionIndex}
            reset={question.reset}
            showBlockquote={false}
            text={question.play.prompt}
          />
          <TextField
            handleChange={this.handleInstructionsChange}
            id={instructionsInputId}
            label="Instructions"
            optional
            value={question.play.instructions}
          />
          <CuesField
            cues={question.play.cues || {}}
            handleCuesChange={this.handleCuesChange}
            questionIndex={questionIndex}
          />
          <div className="field">
            <label>Field Labels</label>
            {this.renderStepLabels()}
          </div>
        </div>
        <SlidePreview slideNumber={questionIndex}>
          <StudentMultistep data={question} />
        </SlidePreview>
      </div>
    )
  }

}

export default CustomizeMultistep
